// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__16vRf","colorBar":"Card_colorBar__3NgdH","course":"Card_course__3P8Cz","bottom":"Card_bottom__3lNbG","lenght":"Card_lenght__3Ecgj"};